import { render, staticRenderFns } from "./Entradas.vue?vue&type=template&id=033202e0&"
import script from "./Entradas.vue?vue&type=script&lang=js&"
export * from "./Entradas.vue?vue&type=script&lang=js&"
import style0 from "./Entradas.vue?vue&type=style&index=0&id=033202e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports